<template>
  <div
    v-if="isFrameType"
    class="update-log-text"
    :style="getTechnologyFrameTextColor"
    @click="handleClick"
  >
    {{ t('layout.header.updateLog') }}
  </div>
  <Tooltip v-else :title="t('layout.header.updateLog')" placement="bottom" :mouseEnterDelay="0.5">
    <span class="update-log-icon-wrap" @click="handleClick">
      <NotificationOutlined class="update-log-icon" />
    </span>
  </Tooltip>
</template>

<script setup lang="ts">
import { Tooltip } from 'ant-design-vue';
import { NotificationOutlined } from '@ant-design/icons-vue';
import { useI18n } from 'vue-i18n';
import { useAppFrame } from '@/hooks/useAppFrame';
import emitter from '@/events/eventBus';

const { t } = useI18n();
const { isFrameType, getTechnologyFrameTextColor } = useAppFrame();

function handleClick() {
  emitter.emit('showUpdateLogModal');
}
</script>

<style scoped lang="less">
.update-log-text {
  font-size: 14px;
  cursor: pointer;
}

.update-log-icon-wrap {
  display: inline-flex;
  align-items: center;
  margin-right: 3px;
  cursor: pointer;
}

.update-log-icon {
  font-size: 16px;
}
</style>
